import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  click(event) {
    event.preventDefault();

    const request = new XMLHttpRequest();
    const url = this.linkTarget.dataset.url;
    const filename = this.linkTarget.dataset.filename;

    $(request).offon('readystatechange', () => {
      if (request.readyState == 4) {
        if (window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveBlob(request.response, filename);
        } else {
          const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

          if (iOS) {
            window.location.href = url;
          } else {
            const a = document.createElement('a');
            const object_url = URL.createObjectURL(request.response);
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = object_url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(object_url);
            a.remove();
          }
        }
      }
    });

    request.open('get', url);
    request.responseType = 'blob';
    request.send();
  }
}
